<template>
  <div class="no-polls-container">
    <vote-loader class="loader" />
    <div class="message-info">
      <div>{{ $t('TXT.WALL.NO_ACTIVE_POLL') }}</div>
    </div>
  </div>
</template>

<script>
import VoteLoader from './VoteLoader/VoteLoader';

export default {
  name: 'no-active-polls',
  components: {
    VoteLoader
  }
};
</script>

<style lang="scss" scoped>
.no-polls-container {
  margin-top: 20vh;
  text-align: center;
}
.loader {
  display: inline-block;
  height: 300px;
  width: 300px;
}
.message-info {
  margin-top: 10px;
  font-size: 22px;
}
</style>
